import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNukeComponent } from './simple-icons-nuke.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNukeComponent ],
    exports:      [ SimpleIconsNukeComponent ],
    bootstrap:    []
})
export class SimpleIconsNukeModule {}
